
import React from 'react';
import styles from './_loading-panel.module.scss';

export interface LoadingPanelProps {
  style?: React.CSSProperties;
  label: string;
}

export default function LoadingPanel (props:  LoadingPanelProps) {
  return (
    <div style={props.style} className={styles.loadingPanelContainer}>            
      <div className="k-loading-image">        
      </div>      
      <div className="k-loading-color"></div>      
      <img style={{position: 'absolute', marginBottom: '8px'}} src="/assets/header-logo.png" alt="loading" />
      <span style={{color: '#d95137', fontWeight: 'bold'}}>{props.label}</span>
    </div>
  );
}
